export default __webpack_public_path__ + "static/media/330_store03-it-web.268ea98b.png";